import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { formatTimestampUTC } from '../../../component/helpers/tablesFuncHelpers';
import CameraHealthHelpModal from './CameraHealthHelpModal';

const CameraHealthAssetsModal = (props) => {
    const { issue, devices, onHide } = props;
    const { t } = useTranslation('translation', { keyPrefix: 'dashboardPage.fleetCameraHealth' });
    const [showHelp, setShowHelp] = useState(false);

    return (
        <>
            <Modal show onHide={onHide} className="camera-health-modal">
                <Modal.Header closeButton className={`camera-health-modal__header camera-health-modal__header--${issue.severity}`}>
                    {issue.icon && <span className="camera-health-modal__header-icon"><issue.icon /></span>}
                    <Modal.Title>{issue.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="camera-health-modal__label">{t('labelAffectedAssets')}</div>
                    <table className="camera-health-modal__table">
                        <thead>
                            <tr>
                                <th>{t('columnAssetName')}</th>
                                <th>{issue.assetColumnLabel}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {devices.map((device) => (
                                <tr key={device.device_id}>
                                    <td>{device.vehicle_name}</td>
                                    <td>{formatTimestampUTC(device.health?.[issue.key]?.last_ts)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button type="button" className="camera-health-modal__help-link" onClick={() => setShowHelp(true)}>
                        {t('linkWhatCanIDo')}
                    </button>
                </Modal.Body>
            </Modal>
            {showHelp && <CameraHealthHelpModal issue={issue} onHide={() => setShowHelp(false)} />}
        </>
    );
};

CameraHealthAssetsModal.propTypes = {
    issue: PropTypes.objectOf(PropTypes.any).isRequired,
    devices: PropTypes.arrayOf(PropTypes.object).isRequired,
    onHide: PropTypes.func.isRequired,
};

export default CameraHealthAssetsModal;
